<template>
	<AtomInputUtilWrapper
		:title="title"
		:is-required="isRequired"
		:error-messages="errorMessages"
		no-error-icons
	>
		<div class="flex flex-wrap gap-x-12 gap-y-4 py-5">
			<AtomInputRadio
				v-for="option in options"
				:key="`atom-input-radio-group-${name}-${option}`"
				v-model="model"
				:name="name"
				:title="option"
				:value="option"
				:is-required="isRequired"
				@change="validate(option)"
			/>
		</div>
	</AtomInputUtilWrapper>
</template>

<script lang="ts" setup>
import type { InputPropDefaultsType } from '#base/core/types/InputPropDefaultsType';
import validatorStringInput from '#base/helpers/validators/validatorStringInput';

const props = defineProps<
	InputPropDefaultsType & {
		title: string;
		options: string[];
	}
>();

const model = defineModel<string>();

const errorMessages = ref<string[]>([]);

function validate(value: string) {
	errorMessages.value = [
		...validatorStringInput(value, {
			isRequired: props.isRequired,
			isDisabled: props.isDisabled,
			fieldName: props.title,
		}),
	];
}
</script>
